export default class Features {
  static init() {}

  static showFeatureImageVideo(accordion_target_id) {
    const target = document.querySelector('[data-feature-item="' + accordion_target_id + '"]');
    if (!target) return;
    const section = target.closest('.ec-b-features');
    if (!section) return;
    const wasActive = target.getAttribute('data-feature-active') === 'true';
    section.querySelectorAll('[data-feature-item]').forEach(item => {
      item.setAttribute('data-feature-active', 'false');
    });
    if (!wasActive) target.setAttribute('data-feature-active', 'true');
  }

  static closeFeatureAccordions(accordion_target) {
    const section = accordion_target && accordion_target.closest('.ec-b-features');
    if (!section) return;
    section.querySelectorAll('[data-accordion-item]').forEach(accordion => {
      if (accordion === accordion_target) return;
      accordion.setAttribute('data-accordion-active', 'false');
      const button = accordion.querySelector('[data-accordion-button]');
      if (button) button.setAttribute('aria-expanded', 'false');
    });
  }
}
